import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { StatusLabel as StatusLabelComponent } from '../../../../components/Status';
import { trackStatusLabelClick } from '../../utils/tracking';
import { TThunkDispatch } from '../../../../types/redux';
import { ECode } from '../../../../repositories/price-estimator/entities/thin_client_info/MyHomeStatusInfoSchema';
import { selectCurrentStatus } from '../../../../selectors/status';
import { statusListLoad } from '../../../../actions/status';

export const StatusLabel: React.FC = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const currentStatus = useSelector(selectCurrentStatus);

  const onStatusListOpen = React.useCallback(async () => {
    trackStatusLabelClick();
    await dispatch(statusListLoad());
  }, [dispatch]);

  if (!currentStatus || currentStatus.code === ECode.Other) {
    return null;
  }

  const theme = currentStatus.code === ECode.NotSelected ? 'warning' : 'default';

  return <StatusLabelComponent onClick={onStatusListOpen} theme={theme} text={currentStatus.text} />;
};
